// extracted by mini-css-extract-plugin
export default {"search":"MX9T1RNRn_KGAmblqLuO","searchIcon":"lZKDdyPVgSrWd1A1Aziw","searchInput":"WD3qLpYwWVKWcDIB6gSi"};